'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import {
    console,
    ajax,
    layout,
} from '@hms-dbmi-bgm/shared-portal-components/es/components/util';

export class BigDropdownPageLoader extends React.PureComponent {
    static defaultProps = {
        treeURL: '/help',
        session: false,
    };

    constructor(props) {
        super(props);
        this.loadPage = this.loadPage.bind(this);
        this.state = {
            menuTree: null,
            isLoadingMenuTree: false,
        };
    }

    componentDidMount() {
        const { menuTree, isLoadingMenuTree } = this.state;
        if (!menuTree && !isLoadingMenuTree) {
            this.loadPage();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { session } = this.props;
        if (session !== prevProps.session) {
            this.loadPage();
        }
    }

    /**
     * Performs AJAX request to `props.treeURL` and saves response to
     * `state.menuTree`. Manages `state.isLoadingMenuTree` appropriately.
     */
    loadPage() {
        const { isLoadingMenuTree } = this.state;
        const { treeURL } = this.props;
        if (isLoadingMenuTree) {
            console.error('Already loading Help tree');
            return;
        }
        this.setState({ isLoadingMenuTree: true }, () => {
            ajax.load(
                treeURL,
                (res) => {
                    if (res && res.identifier) {
                        this.setState({
                            menuTree: res,
                            isLoadingMenuTree: false,
                        });
                    } else {
                        this.setState({
                            menuTree: null,
                            isLoadingMenuTree: false,
                        });
                    }
                },
                'GET',
                () => {
                    this.setState({ menuTree: null, isLoadingMenuTree: false });
                }
            );
        });
    }

    render() {
        const { children, ...passProps } = this.props;
        const childProps = { ...passProps, ...this.state };
        return React.Children.map(children, function (child) {
            return React.cloneElement(child, childProps);
        });
    }
}
